import { serialize as og_serialize } from 'object-to-formdata'

const defaultOptions = { indices: true, allowEmptyArrays: true }

export const serialize = (param, options) => og_serialize(param, { ...defaultOptions, ...options })
